import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/layout'
import Billboard from '../components/Billboard'

import Seo from '../components/seo'
import CaseStudiesList from "../components/pages/case-studies/CaseStudiesList/CaseStudiesList";

const CaseStudiesPage = ({ data }) => {
    const caseStudies = data.allFile.edges

    const caseStudiesSorted = caseStudies.sort((a, b) => {
        const firstString = a.node.childMarkdownRemark.frontmatter.slug || ""
        const secondString = b.node.childMarkdownRemark.frontmatter.slug || ""
        if (firstString < secondString) {
            return -1;
        }
        if (firstString > secondString) {
            return 1;
        }
        return 0;
    })

    return (
        <Layout>
            <Seo
                title="Case Studies"
                description="Cloudnexa's Case Studies."
            />

            <Billboard className="Billboard--resources" color="white">
                <div className="Billboard__top">
                    <h1 className="Billboard__title">Case Studies</h1>
                    <div className="Billboard__lead">
                        Insights from the AWS Experts at Cloudnexa
                    </div>

                    <div className="Billboard__cta" />
                </div>
            </Billboard>

            <CaseStudiesList caseStudies={caseStudiesSorted} />

        </Layout>
    )
}

export const query = graphql`
  {
        allFile(
          filter: {
            internal: {mediaType: {eq: "text/markdown"}}, 
            sourceInstanceName: {eq: "case-studies"}
          }
        ) {
          edges {
            node {    
              id              
              childMarkdownRemark {
                id
                frontmatter {
                    slug
                    title
                    summary
                    company {
                        name
                    }
                    video {
                        url
                    }
                }
                fields {
                  companyLogo {
                    publicURL
                  }
                }
              }
            }
          }
        }  
  }  
`

export default CaseStudiesPage
